import { render, staticRenderFns } from "./EstimageMessageView.vue?vue&type=template&id=df49fb20"
import script from "./EstimageMessageView.vue?vue&type=script&lang=js"
export * from "./EstimageMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df49fb20')) {
      api.createRecord('df49fb20', component.options)
    } else {
      api.reload('df49fb20', component.options)
    }
    module.hot.accept("./EstimageMessageView.vue?vue&type=template&id=df49fb20", function () {
      api.rerender('df49fb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageView.vue"
export default component.exports